import { render, staticRenderFns } from "./gRNA.vue?vue&type=template&id=1c92d914&scoped=true"
import script from "./gRNA.vue?vue&type=script&lang=js"
export * from "./gRNA.vue?vue&type=script&lang=js"
import style0 from "./gRNA.vue?vue&type=style&index=0&id=1c92d914&prod&lang=less&scoped=true"
import style1 from "./gRNA.vue?vue&type=style&index=1&id=1c92d914&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c92d914",
  null
  
)

export default component.exports